import React, { useContext } from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import { navigate } from "gatsby-link"
import "./navbar.css"
import { FaBars } from "react-icons/fa"
import { GiShoppingCart } from "react-icons/gi"
import { GoSignIn } from "react-icons/go"
import { BsPersonFill } from "react-icons/bs"
import { isLoggedIn, logout } from "../../../utils/auth"
import logo from "../../../images/logo.png"
import Search from "../../module/search/Search"
import { StoreContext } from "../../../context/store"
const Navbar = ({ toggleSidebar, setIsOpen, isOpen }) => {
  const { category, subcategory } = useStaticQuery(
    graphql`
      {
        category: allSanityCategory {
          nodes {
            title
            _id
            slug {
              current
            }
          }
        }
        subcategory: allSanitySubcategory {
          nodes {
            id
            category {
              _id
              slug {
                current
              }
            }
            slug {
              current
            }
            title
          }
        }
      }
    `
  )
  const categories = category.nodes
  const subcategories = subcategory.nodes

  const { cart, toggleCart, cartOpen, setCartOpen } = useContext(StoreContext)

  return (
    <nav className="navbar">
      <div className="nav-center">
        {isOpen && (
          <div className="z-10 fixed inset-0 transition-opacity">
            <div
              aria-label="Hide Menu"
              onKeyPress={e => e.key === "esc" && setIsOpen(false)}
              role="button"
              onClick={() => setIsOpen(false)}
              className="absolute inset-0 bg-black opacity-50"
              tabIndex="0"
            ></div>
          </div>
        )}
        {cartOpen && (
          <div className="z-10 fixed inset-0 transition-opacity">
            <div
              aria-label="Hide Cart"
              onKeyPress={e => e.key === "esc" && setCartOpen(false)}
              role="button"
              onClick={() => setCartOpen(false)}
              className="absolute inset-0 bg-black opacity-50"
              tabIndex="0"
            ></div>
          </div>
        )}

        <div className="nav-header">
          <button className="toggle-btn" onClick={toggleSidebar}>
            <FaBars />
          </button>
          <Link to="/">
            <img src={logo} alt="gadget store bd logo" />
          </Link>
          <button
            onClick={() => toggleCart(!cartOpen)}
            className="cart-icon shadow-lg shadow-primary/20 md:hidden"
          >
            <GiShoppingCart />
            <span className="cart-count">{cart.length}</span>
          </button>
        </div>
        <Search />
        <div className="md:col-auto md:flex w-full hidden  items-center ">
          <button onClick={() => toggleCart(!cartOpen)} className="cart-icon">
            <GiShoppingCart />
            <span className="cart-count">{cart.length}</span>
          </button>
          <button
            onClick={() => toggleCart(!cartOpen)}
            className="p-2 bg-primary text-white text-sm"
          >
            My Cart
          </button>
          {!isLoggedIn() ? (
            <>
              {" "}
              <Link to="/login" className="log-btn  p-1">
                <GoSignIn /> Login
              </Link>
              <Link to="/register" className="log-btn p-1">
                <BsPersonFill /> Register
              </Link>{" "}
            </>
          ) : (
            <div className="flex  ">
              <button
                className="p-2 bg-primary text-white text-sm mx-3 "
                onClick={event => {
                  event.preventDefault()
                  logout().then(() => navigate("/login"))
                }}
              >
                Log Out
              </button>
              <button className="p-2 bg-primary text-white text-sm">
                <Link to="/customer/account" className="inline">
                  My Account
                </Link>
              </button>
            </div>
          )}
        </div>

        <div className="w-full h-11 bg-primary md:block hidden  col-span-full rounded-sm">
          <div className="flex justify-center ">
            {categories.map(category => {
              const subCate = subcategories.filter(
                sub => sub.category._id === category._id
              )
              return (
                <div
                  className="border-white border-l-2  hover:bg-black relative group text-white uppercase  text-sm text-center duration-500"
                  key={category._id}
                >
                  <Link
                    className="px-4 py-3 block"
                    to={`/${category.slug.current}`}
                  >
                    {category.title}
                  </Link>
                  <div className="  group-hover:block hidden absolute left-0 z-50 w-full top-10">
                    {subCate.map(s => {
                      return (
                        <Link
                          className="hover:bg-primary duration-500 border-b border-red-100 first:border-t last:border-b-0 bg-black  px-4 py-1 first:pt-2.5 first:pb-1.5 last:pb-2 block  "
                          key={s.id}
                          to={`/${s.category.slug.current}/${s.slug.current}`}
                        >
                          {s.title}
                        </Link>
                      )
                    })}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
